module.exports = "/_next/static/images/e7d0b2d7546e3db577277c22a2017e0c-nubanker-ds@0.5x.jpg";